import { type IUserTenantAccess } from '@inpart-io/devtools-iap';
import { type GetterTree } from 'vuex';

import { type IUserTenantAccessState } from './types';

export const GET_FROM_USER = 'getFromUser';

export const getters: GetterTree<IUserTenantAccessState, unknown> = {
    [GET_FROM_USER]: (_state: IUserTenantAccessState) => {
        return (dobjId: number): IUserTenantAccess | undefined => {
            const userTenantAccessId = _state.byUser.get(dobjId);
            return userTenantAccessId !== null && userTenantAccessId !== undefined ? _state.dataObjectList.get(userTenantAccessId) : undefined;
        };
    }
};
